var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckRound = function SvgCheckRound(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Check Round",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "AZ_DLS_Icons",
    transform: "translate(-385.000000, -345.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Library_Items-/-Title-/-Descriptions-Copy-8",
    transform: "translate(33.000000, 292.000000)",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 16,
    letterSpacing: -0.0266666671
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.086957)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(385.000000, 345.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.795,15.8749928 L5.325,12.4049928 C5.13816847,12.2177401 4.88451764,12.1125072 4.62,12.1125072 C4.35548236,12.1125072 4.10183153,12.2177401 3.915,12.4049928 C3.525,12.7949928 3.525,13.4249928 3.915,13.8149928 L8.095,17.9949928 C8.485,18.3849928 9.115,18.3849928 9.505,17.9949928 L20.085,7.4149928 C20.475,7.0249928 20.475,6.3949928 20.085,6.0049928 C19.8981685,5.81774013 19.6445176,5.7125072 19.38,5.7125072 C19.1154824,5.7125072 18.8618315,5.81774013 18.675,6.0049928 L8.795,15.8749928 Z",
    id: "icon/navigation/check_24px"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckRound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "check-round.020ed83ce1ee1146ffc3f4e52f5a20df.svg";